enum PaymentType {
  ACTIVATE_PLAN = 'ACTIVATE_PLAN',
  ADD_PRODUCT = 'ADD_PRODUCT',
  ADD_SEAT = 'ADD_SEAT',
  CHANGE_PLAN = 'CHANGE_PLAN',
  CREATE_VIRTUAL_ACCOUNT = 'CREATE_VIRTUAL_ACCOUNT',
  PAY_INVOICE = 'PAY_INVOICE',
  SUBSCRIBE_PLAN = 'SUBSCRIBE_PLAN',
}

export default PaymentType;
